import type { Banner } from '~/handlers/ports/api-fetch-banners.port';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';

const GUEST_BANNER_SLUG = 'banner-home-logged-out';

/**
 * Busca o banner institucional exclusivo pra visitante deslogado.
 * Categoria cadastrada à parte no backoffice (slug fixo), sem valor/percentual
 * de bônus — ver ENG-400 item 5.
 */
export async function fetchGuestBannerHandler(): Promise<Banner | null> {
  try {
    const response = await fetch(
      `${getApostatudoApiUrl()}/banners/${GUEST_BANNER_SLUG}`,
      { headers: { Accept: 'application/json' } },
    );

    if (!response.ok) return null;

    const data = await response.json();
    const raw = Array.isArray(data) ? data[0] : null;

    if (!raw) return null;

    return {
      id: raw.id,
      filename: raw.filename,
      url: raw.url,
      link_url: raw.link_url ?? null,
      button_text: raw.button_text ?? null,
      type: 'HOME_BANNER',
      created_at: raw.created_at ?? '',
      updated_at: raw.updated_at ?? '',
    };
  } catch (error) {
    console.error('[fetchGuestBannerHandler] failed to fetch banner', error);

    return null;
  }
}
